import React, { FC, useEffect, useState } from 'react';

import '../css/normalize.css';
import '../css/webflow.css';
import '../css/salarysimwebflow.css';
import '../css/salarysimwebflow_custom.css';
import '../css/salarysim.css';

import { UseSalarySimContext } from '../Context/SalarySimContext';
import { UseTranslationContext } from '../Context/TranslationContext';

interface StepperButtonProps {
  currentStep: number,
  buttonStep: number,
  requestStepChange(wantedStep: number) : void // for navigation in the stepper
  buttonTitle : string,
}

const StepButtonComponent: FC<StepperButtonProps> = (props) => {

  const {getKeyFromKeyId} = UseTranslationContext()
  
return (
  <div className={props.currentStep == props.buttonStep ?"step w-inline-block stepCurrent":"step w-inline-block"}>
  <button id={"stepper-option" + props.buttonStep} aria-label={getKeyFromKeyId(props.buttonTitle)} onClick={() => props.requestStepChange(props.buttonStep)} type="button" className={props.currentStep == props.buttonStep ?"step actif w-inline-block invisibleButton":"step w-inline-block invisibleButton"}>
    <div className={props.currentStep == props.buttonStep ? "stepper-number" : "stepper-number inactif"}>
      <div aria-hidden="true" className="number">{props.buttonStep}</div>
    </div>
  </button>
  <div aria-label={"Step" + props.buttonStep} onClick={() => props.requestStepChange(props.buttonStep)} className={props.currentStep == props.buttonStep? "title-stepper" : "title-stepper inactif"}>{getKeyFromKeyId(props.buttonTitle)}</div>
</div>
  )
}

export default StepButtonComponent;
  


